/**
 * Click-to-edit cell: shows value until clicked, then inline input; on blur/Enter saves.
 * Use for key-value tables where the value can be edited (e.g. listing preview).
 */
import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * @param {{
 *   fieldKey: string,
 *   displayValue: string | number | null | undefined,
 *   isEditing: boolean,
 *   editingValue: string,
 *   onEditingValueChange: (v: string) => void,
 *   onStartEdit: (fieldKey: string, displayValue: unknown) => void,
 *   onSaveEdit: () => void,
 *   className?: string,
 *   inputClassName?: string
 * }} props
 */
const EditableCell = ({
  fieldKey,
  displayValue,
  isEditing,
  editingValue,
  onEditingValueChange,
  onStartEdit,
  onSaveEdit,
  className = '',
  inputClassName = 'listing-edit-input'
}) => {
  if (isEditing) {
    return (
      <Form.Control
        size="sm"
        autoFocus
        value={editingValue}
        onChange={(e) => onEditingValueChange(e.target.value)}
        onBlur={onSaveEdit}
        onKeyDown={(e) => e.key === 'Enter' && onSaveEdit()}
        className={inputClassName}
        aria-label={`Edit ${fieldKey}`}
      />
    );
  }
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() => onStartEdit(fieldKey, displayValue)}
      onKeyDown={(e) => e.key === 'Enter' && onStartEdit(fieldKey, displayValue)}
      className={`listing-value-editable text-break ${className}`.trim()}
    >
      {displayValue ?? '—'}
    </span>
  );
};

export default EditableCell;
